import React, { useState, memo } from 'react';
import PropTypes from 'prop-types';
import ReactCountryFlag from 'react-country-flag';
import ifEmoji from 'if-emoji';

import _get from 'lodash/get';

import { makeStyles } from '@mui/styles';

import CountryCodes from '../data/country-codes';

const useStyles = makeStyles(theme => ({
    country: {
        cursor: 'default',
    },
}));

// windows doesn't ship flag emojis
const emoji = ifEmoji('🇺🇸');
if (!emoji) console.log('flag emoji not supported. Using svg flags');

// Usage: <CountryFlag country="US" />
const CountryFlag = memo(({ country }) => {
    const classes = useStyles();
    let countryCode;

    if (country && country.length > 2) {
        countryCode = Object.keys(CountryCodes).find(key => {
            const value = CountryCodes[key];
            return Array.isArray(value) ? value.includes(country) : value === country;
        });
    } else {
        countryCode = country;
    }
    
    return (
        <span>
            {/* use svg flags when flag emojis are not available  */}
            {emoji
                ? <ReactCountryFlag
                    className={classes.country}
                    countryCode={countryCode}
                    aria-label={_get(CountryCodes, `[${countryCode}][0]`, '')}
                    title={_get(CountryCodes, `[${countryCode}][0]`, '')}
                    target="_blank"/>
                : <ReactCountryFlag
                    className={classes.country}
                    countryCode={countryCode}
                    aria-label={_get(CountryCodes, `[${countryCode}][0]`, '')}
                    title={_get(CountryCodes, `[${countryCode}][0]`, '')}
                    target="_blank" svg/>
            }
        </span>
    );
});
CountryFlag.propTypes = {
    country: PropTypes.string.isRequired,
};

export default CountryFlag;
